import { intersection, isObject } from "lodash/fp"; // TODO: Get these from the theme

var BREAKPOINTS_KEYS = ["xs", "s", "m", "l", "xl", "dt_viewport_xs", "dt_viewport_s", "dt_viewport_m", "dt_viewport_l", "dt_viewport_xl"];
export var isResponsiveValue = function isResponsiveValue(cssPropValue) {
  return isObject(cssPropValue) && intersection(BREAKPOINTS_KEYS, Object.keys(cssPropValue)).length > 0;
};
export var transformResponsiveObjectIntoResponsiveArray = function transformResponsiveObjectIntoResponsiveArray(responsiveObject) {
  var responsiveArray = [responsiveObject.xs || responsiveObject.dt_viewport_xs || null, responsiveObject.s || responsiveObject.dt_viewport_s || null, responsiveObject.m || responsiveObject.dt_viewport_m || null, responsiveObject.l || responsiveObject.dt_viewport_l || null, responsiveObject.xl || responsiveObject.dt_viewport_xl || null];
  return responsiveArray;
};
//# sourceMappingURL=responsiveValues.js.map